import React from 'react'

const CarePlanHeader = ({ carePlan, specialty, isHeroVisible = true }) => {

  return (
    <section className={`care-plan-header-compact hero-section ${!isHeroVisible ? 'hidden' : ''}`}>
      <div className="container">
        <div className="care-plan-header-content">
          <h1 className="care-plan-title-compact">{carePlan.title}</h1>
          <p className="care-plan-subtitle-compact">{carePlan.description}</p>
          <div className="care-plan-category">
            <strong>Category:</strong> {carePlan.category}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CarePlanHeader
